<template lang="html">
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Tipo de variações"
    type-modal="add_variation_type_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">

        <d-form-row>
          <d-col md="12" class="form-group">
            <label for="feName">Nome</label>
            <d-form-input type="text" v-model="model.name" id="feName" placeholder="Nome" />
          </d-col>
        </d-form-row>
        <d-form-row v-if="model.id == null">
          <d-col md="12" class="form-group">
            <label >Opções</label>
            <ul class="options">
              <li v-for="(value, index) in model.values" :key="index">
                <d-form-input type="text" v-model="value.name" placeholder="Opção" @focus.native="addNewRow(index)"/>
              </li>
            </ul>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="cancel()"
        class="btn btn-sm btn-secondary mr-4"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import ProductService from '_services/rest/modules/product';
import { _LOAD_TYPE_MODEL_, MODEL_TYPE, _RELOAD_VARIATION_, MODEL_TYPE_OPTION } from '../ProductModel';

export default {
  name: 'add-variation-type',
  components: {
    ModalTemplate,
  },
  props: {},
  data() {
    return {
      loading: false,
      model: cloneDeep(MODEL_TYPE),
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    addNewRow(index) {
      if ((index === this.model.values.length - 1) &&
        (index === 0 || this.model.values[index - 1].name != null)
      ) {
        this.model.values.push({ ...MODEL_TYPE_OPTION });
      }
    },
    cancel() {
      this.setToggle({ type: 'add_variation_type_modal', bool: false });
    },
    removeEmptyRow() {
      if (this.model.values) {
        this.model.values = this.model.values.filter(value => value.name !== null);
      }
    },
    save() {
      this.toggleLoading();
      this.removeEmptyRow();
      const { product } = this.$store.state.product;
      const productId = (this.model.id == null) ? `${product.id}/` : '';
      ProductService.saveVariationType(this.model, productId)
        .then(() => {
          Events.$emit(_RELOAD_VARIATION_);
          this.setToggle({ type: 'add_variation_type_modal', bool: false });
        })
        .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }))
        .finally(() => this.toggleLoading());
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
  },
  mounted() {
    Events.$on(_LOAD_TYPE_MODEL_, newValue => {
      this.model = cloneDeep(newValue);
    });
  },
};
</script>

<style lang="scss" scoped>
ul {
  &.options {
    list-style: none;
    padding: 0;
  }
}
</style>
